export const defaultProfile = "../../../assets/images/profile.png";